module.exports = __webpack_public_path__ + "img/news-bg.093331f8.jpg";